import "@fontsource-variable/geist";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AgentApplication } from "./AgentApplication.js";
import { readBootstrap } from "./bootstrap.js";
import { setAgentBrand } from "./brand.js";
import { AppErrorBoundary } from "./components/AppErrorBoundary.js";
import { agentErrorReporter, enableAgentErrorReporting } from "./error-reporting.js";
import "./styles.css";

const root = document.querySelector<HTMLElement>("#root");
if (!root) throw new Error("Agent application root is missing");

const bootstrap = readBootstrap(root);
if (bootstrap.brand) setAgentBrand(bootstrap.brand);

enableAgentErrorReporting();

createRoot(root, agentErrorReporter.reactRootOptions()).render(
  <StrictMode>
    <AppErrorBoundary>
      <AgentApplication bootstrap={bootstrap} />
    </AppErrorBoundary>
  </StrictMode>,
);
